
const { ccclass, property } = cc._decorator;
import ModelBase from "../../../../framework/core/mvvm/model_base"

import * as ProtoPokerRoom from "../../net/proto/proto_poker_room";
import * as ProtoPokerLogin from "../../net/proto/proto_poker_login";
import NetMsgDataBase from "../../net/net_msg_data_table_base";


@ccclass
export default class TableBaseModel extends ModelBase {

    constructor() {
        super()
    }

    send_ping_request(){
        let protoData: ProtoPokerLogin.Login.IPingReq = {}
        this.sendMsg(NetMsgDataBase.Ready, protoData)
    }

    send_ready_request(isReady: boolean){
        let protoData: ProtoPokerRoom.Room.IReadyReq = {
            isReady: isReady ? 1 : 0,
        }
        this.sendMsg(NetMsgDataBase.Ready, protoData)
    }

    send_start_request(){
        let protoData: ProtoPokerRoom.Room.IStartReq = {}
        this.sendMsg(NetMsgDataBase.Start, protoData)
    }

    send_leave_request(){
        let protoData: ProtoPokerRoom.Room.ILeaveReq = {}
        this.sendMsg(NetMsgDataBase.Leave, protoData)
    }    

    send_chat_request(chatMsgType: number, text: string){
        let chatmsg: ProtoPokerRoom.Room.IChatMsg = {
            msgType: chatMsgType,
            text: text
        }
        let protoData: ProtoPokerRoom.Room.IChatMsgReq = {
            chatMsg: chatmsg
        }
        this.sendMsg(NetMsgDataBase.Chat, protoData)
    }

    send_dissolve_request(agree: boolean){
        let protoData: ProtoPokerRoom.Room.IFreeReq = {
            agree: agree
        }
        this.sendMsg(NetMsgDataBase.FreeRoom, protoData)
    }


    send_custominfo_change_request(text: string){
        let protoData: ProtoPokerRoom.Room.ICustomInfoChangeReq = {
            customInfo: text,
        }
        this.sendMsg(NetMsgDataBase.CustomInfo, protoData)
    }

    send_kick_request(playerId: number){
        let protoData: ProtoPokerRoom.Room.IKickPlayerReq = {
            playerId: playerId,
        }
        this.sendMsg(NetMsgDataBase.KickPlayer, protoData)
    }

    send_intrust_request(apply: boolean){
        let protoData: ProtoPokerRoom.Room.IIntrustReq = {
            action: apply ? 1: 2,
        }
        this.sendMsg(NetMsgDataBase.Intrust, protoData)
    }

    send_recharge_request(open: boolean){
        let protoData: ProtoPokerRoom.Room.IRechargeReq = {
            open: open,
        }
        this.sendMsg(NetMsgDataBase.UserRecharge, protoData)
    }

    send_user_coinbalance_request(){
        let protoData: ProtoPokerRoom.Room.IUserCoinBalanceReq = {
        }
        this.sendMsg(NetMsgDataBase.UserCoinBalance, protoData)
    }
}
